import { forwardRef } from 'react';
import { cva } from 'class-variance-authority';
import { cn } from '../../utils/cn';

const alertVariants = cva(
	// Base styles
	"relative w-full rounded-lg border p-4 font-roboto",
	{
		variants: {
			variant: {
				default: "bg-card border-border text-foreground",
				destructive: "bg-red-50 border-red-200 text-red-900 dark:bg-red-500/10 dark:border-red-500/30 dark:text-red-200",
				success: "bg-green-50 border-green-200 text-green-900 dark:bg-green-500/10 dark:border-green-500/30 dark:text-green-200",
				warning: "bg-yellow-50 border-yellow-200 text-yellow-900 dark:bg-yellow-500/10 dark:border-yellow-500/30 dark:text-yellow-200",
				info: "bg-brand-50 border-brand-200 text-brand-900 dark:bg-brand-500/10 dark:border-brand-500/30 dark:text-brand-200",
			}
		},
		defaultVariants: {
			variant: "default"
		}
	}
);

const Alert = forwardRef(({
	className,
	variant,
	...props
}, ref) => (
	<div
		ref={ref}
		role="alert"
		className={cn(alertVariants({ variant, className }))}
		{...props}
	/>
));
Alert.displayName = "Alert";

const AlertTitle = forwardRef(({ className, children, ...props }, ref) => (
	<h5
		ref={ref}
		className={cn("mb-1 font-medium leading-none tracking-tight", className)}
		{...props}
	>
		{children}
	</h5>
));
AlertTitle.displayName = "AlertTitle";

const AlertDescription = forwardRef(({ className, ...props }, ref) => (
	<div
		ref={ref}
		className={cn("text-sm opacity-90", className)}
		{...props}
	/>
));
AlertDescription.displayName = "AlertDescription";

export { Alert, AlertTitle, AlertDescription, alertVariants }; 